import { cancelOrder, setOrderPaymentMethod } from '../../../actions';
import { identityPayload, createReducer, forAction } from '../../../utils';

const initialState = 'terminal';

export default createReducer(
  [forAction(setOrderPaymentMethod, identityPayload)],
  initialState,
  [cancelOrder],
);
